/** Сколько отделов видно до кнопки «показать все». */
export const PHONEBOOK_COLLAPSED_COUNT = 5
